<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Header
      :showGoBack="true"
      :showDocument="true"
    />

    <main
      class="scrollable container"
      :style="{paddingTop: '10px'}"
    >
      <!-- card -->
      <img
        src="@/assets/cards/05.png"
        alt="card"
        style="width: 90%; height: auto; margin: 0 auto; margin-bottom: 20px"
      />

      <!-- buttons -->
      <ul
        :class="'row-center'"
        :style="{gap: '17px', marginBottom: '30px'}"
      >
        <li
          v-for="e in buttons"
          :key="e.id"
          class="row-center {{e.id === 1 ? 'clickable' : ''}}"
          :style="{
            height: '50px',
            width: '100%',
            backgroundColor: '#FFF7F2',
            borderRadius: '10px',
            border: '1px solid #FFEFE6',
            paddingLeft: '14px',
            paddingRight: '14px',
          }"
        >
          <img
            v-if="e.icon"
            :src="e.icon"
            alt="icon"
            :style="{width: '24px', height: '18px', marginRight: '12px'}"
          />
          <h5 :style="{marginRight: 'auto'}">{{ e.title }}</h5>
          <Switcher v-if="e.switcher" />
          <PlusSvg v-if="e.plusIcon" />
        </li>
      </ul>

      <!-- limits -->
      <section :style="{marginBottom: '30px'}">
        <span
          class="t14"
          :style="{marginBottom: '10px', display: 'block'}"
          >Limits</span
        >
        <ul>
          <li
            :key="e.id"
            v-for="(e, i) in limits"
            @click="e.route && $router.push(e.route)"
            :class="'row-center-space-between clickable'"
            :style="{marginBottom: i === limits.length - 1 ? '0px' : '14px'}"
          >
            <div>
              <div
                :class="'row-center'"
                :style="{gap: '10px', marginBottom: '2px'}"
              >
                <component :is="e.icon" />
                <h5>{{ e.title }}</h5>
              </div>
              <span :class="'t12'">Default limit: {{ e.limit }}</span>
            </div>
            <RightArrowSvg />
          </li>
        </ul>
      </section>

      <!-- Security -->
      <section :style="{marginBottom: '20px'}">
        <span
          class="t14"
          :style="{marginBottom: '10px', display: 'block'}"
          >Security</span
        >
        <ul>
          <li
            :key="e.id"
            v-for="(e, i) in security"
            @click="e.route && $router.push(e.route)"
            :class="'row-center clickable'"
            :style="{
              marginBottom: i === security.length - 1 ? '0px' : '14px',
              gap: '10px',
            }"
          >
            <component :is="e.icon" />
            <h5
              :style="{
                marginRight: 'auto',
                color:
                  e.title === 'Block the card'
                    ? 'var(--main-color)'
                    : e.title === 'Сlose the card'
                    ? 'var(--main-color)'
                    : 'var(--main-dark)',
              }"
            >
              {{ e.title }}
            </h5>
            <RightArrowSvg />
          </li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script setup>
import {useOpacity} from '@/hooks';

// components
import {Header} from '@/components';
import {Switcher} from '@/components';

// svg
import {LockSvg} from '@/assets/svg';
import {PlusSvg} from '@/assets/svg';
import {TrashSvg} from '@/assets/svg';
import {GlobeSvg} from '@/assets/svg';
import {RefreshSvg} from '@/assets/svg';
import {RightArrowSvg} from '@/assets/svg';
import {LimitDollarSvg} from '@/assets/svg';
import {SecurityKeySvg} from '@/assets/svg';

// other
import {routes} from '@/routes';

const opacity = useOpacity();

const buttons = [
  {
    id: 1,
    title: 'Apple Pay',
    icon: require('@/assets/other/03.png'),
    switcher: false,
    plusIcon: true,
  },
  {
    id: 2,
    title: 'Default card',
    icon: '',
    switcher: true,
    plusIcon: false,
  },
];

const limits = [
  {
    id: 1,
    icon: GlobeSvg,
    title: 'Online payments',
    limit: '100 USD per day',
    route: routes.PAYMENTS,
  },
  {
    id: 2,
    icon: LimitDollarSvg,
    title: 'ATM withdrawals',
    limit: '3000 USD per day',
    route: '',
  },
];

const security = [
  {
    id: 1,
    icon: SecurityKeySvg,
    title: 'Change PIN code',
    route: routes.CHANGE_PIN_CODE,
  },
  {
    id: 2,
    icon: RefreshSvg,
    title: 'Reissue the card',
    route: '',
  },
  {
    id: 3,
    icon: LockSvg,
    title: 'Block the card',
    route: '',
  },
  {
    id: 4,
    icon: TrashSvg,
    title: 'Сlose the card',
    route: '',
  },
];
</script>
